import { TOGGLE_DRAW, CLEAR_DRAW, DRAW_FEATURES_CHANGE, TOGGLE_DRAW_BUTTONS_VISIBILITY } from './actions';
import {editCallback} from '../index';

const DefaultState = {
  drawButtonsVisible: false,
  drawActive: false,
  drawType: '',
  featuresGeoJSON: [],
  updateSource: 'OL' //OL UI URL
};

export const MAX_POINTS = 140;

const deepFlatten = arr => [].concat(...arr.map(v => (Array.isArray(v) ? deepFlatten(v) : v)));


export const isMax = (state) => {

  if(state.featuresGeoJSON.length == 0) {
    return false;
  }
  /*
  var points = 0;
  for (var i = state.featuresGeoJSON.features.length - 1; i >= 0; i--) {
    var feature = state.featuresGeoJSON.features[i];
    if (typeof feature.geometry !== 'undefined') {
      let currGeometryPoints = 0;

      if (feature.geometry.geometries) {//GeometryCollection
        currGeometryPoints = feature.geometry.geometries.reduce((acc, curr) => {
          if(curr.type === "Polygon") {
            return acc + deepFlatten(curr.coordinates).length/2 - 1;
          } else {
            return acc + deepFlatten(curr.coordinates).length/2;
          }

        }, 0);
      } else {
        if(feature.geometry.type === "Polygon") {
          currGeometryPoints = deepFlatten(feature.geometry.coordinates).length/2 - 1;
        } else {
          currGeometryPoints = deepFlatten(feature.geometry.coordinates).length/2;
        }
      }

      points += currGeometryPoints;

      if(points >= MAX_POINTS) {
        return true;
      }
    }
  }*/

  return false;
};

export const countPoints = (state) => {

  if(state.featuresGeoJSON.length == 0) {
    return 0;
  }

  var points = 0;
  for (var i = state.featuresGeoJSON.features.length - 1; i >= 0; i--) {
  var feature = state.featuresGeoJSON.features[i];
    if (typeof feature.geometry !== 'undefined') {
      let currGeometryPoints = 0;

      if (feature.geometry.geometries) {//GeometryCollection
        currGeometryPoints = feature.geometry.geometries.reduce((acc, curr) => {
          if(curr.type === "Polygon") {
            return acc + deepFlatten(curr.coordinates).length/2 - 1;
          } else {
            return acc + deepFlatten(curr.coordinates).length/2;
          }

        }, 0);
      } else {
        if(feature.geometry.type === "Polygon") {
          currGeometryPoints = deepFlatten(feature.geometry.coordinates).length/2 - 1;
        } else {
          currGeometryPoints = deepFlatten(feature.geometry.coordinates).length/2;
        }
      }

      points += currGeometryPoints;
    }
  }

  return points;
};

const draw = (state = DefaultState, action) => {
  switch (action.type) {
    case TOGGLE_DRAW:

      action.data.active;
      action.data.drawType;

      if(typeof action.data.active === 'boolean') {

        if(action.data.active) {
          state.drawType = action.data.drawType;
        } else {
          state.drawType = '';
        }

        state.drawType = action.data.active;

      } else {

        if(state.drawType === action.data.drawType) {
          state.drawType = "";
        } else {
          state.drawType = action.data.drawType;
        }

      }

	  if (state.drawType !== '' && editCallback === 'CLEAR_DRAW') {

		state.featuresGeoJSON = {features:[], type: "FeatureCollection"};

            state.updateSource = 'JSAPI';

	  }

      return Object.assign({}, state);

    case CLEAR_DRAW:

    state.drawType = "";
    state.featuresGeoJSON = {features:[], type: "FeatureCollection"};

        if(typeof action.data.updateSource !== 'undefined'){
            state.updateSource = action.data.updateSource;
        } else {
            state.updateSource = 'OL';
        }

      return Object.assign({}, state);

    case DRAW_FEATURES_CHANGE:

      state.featuresGeoJSON = action.data.GeoJSON;

      if(typeof action.data.updateSource !== 'undefined'){
        state.updateSource = action.data.updateSource;
      } else {
        state.updateSource = 'OL';
      }

      return Object.assign({}, state);
    case TOGGLE_DRAW_BUTTONS_VISIBILITY:
      const newButtonVisibilityState = !state.drawButtonsVisible;

      state.drawButtonsVisible = !state.drawButtonsVisible;

      if (newButtonVisibilityState == false) {
        state.drawActive = false;
        state.drawType = '';
      }

        return Object.assign({}, state);
    default:
      return state;
  }
};

export {draw};
